import * as types from "../actions/ActionTypes";
import * as Constants from "../utilities/Constants";
import UrlHelper from "../utilities/UrlHelper";
import AuthenticationType from "../configurations/AuthenticationType";
import { getErrorMessage, scrub } from "../utilities/ErrorMessageHelper";

export const getInitialState = () => (
    {
        redirectLocation: undefined,
        loginFailure: UrlHelper.parseUrl().query.ErrorMessage,
        loginStep: Constants.loginSteps.enterEmail,
        email: UrlHelper.parseUrl().query.email ? UrlHelper.parseUrl().query.email : "",
        authenticationTypeChanged: false,
        emailLoginFailure: UrlHelper.parseUrl().query.ErrorMessage
    });

const loginReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.LOGIN_BY_EMAIL_SUCCEEDED: {
        const authenticationType = action.settings.AuthenticationType;
        if (authenticationType === AuthenticationType.Sso.value && !action.settings.IsUnverified && !action.settings.AuthenticationTypeChanged) {
            const redirectLocation = UrlHelper.getCompleteExternalLoginUrl(action.settings.ExternalLoginUrl);
            return Object.assign({}, state, {
                redirectLocation: redirectLocation,
                loginFailure: undefined,
                emailLoginFailure: undefined
            });
        }

        const nextStep = action.settings.IsUnverified || action.settings.AuthenticationTypeChanged
            ? Constants.loginSteps.verifyEmailForm
            : Constants.loginSteps.enterPassword;

        return Object.assign({}, state, {
            redirectLocation: undefined,
            loginStep: nextStep,
            loginFailure: undefined,
            emailLoginFailure: undefined,
            email: action.email,
            authenticationTypeChanged: action.settings.AuthenticationTypeChanged
        });
    }
    case types.LOGIN_BY_EMAIL_FAILED: {
        return Object.assign({}, state, { emailLoginFailure: getErrorMessage(action.error), email: action.email });
    }
    case types.BACK_TO_EMAIL_FORM: {
        return Object.assign({}, state, { loginStep: Constants.loginSteps.enterEmail, loginFailure: undefined, emailLoginFailure: undefined });
    }
    case types.BACK_TO_SEND_VERIFY_EMAIL_FORM: {
        return Object.assign({}, state, { loginStep: Constants.loginSteps.verifyEmailForm, loginFailure: undefined, emailLoginFailure: undefined });
    }
    case types.BACK_TO_PASSWORD_FORM: {
        return Object.assign({}, state, { loginStep: Constants.loginSteps.enterPassword, loginFailure: undefined, emailLoginFailure: undefined });
    }
    case types.START_RESET_PASSWORD_SUCCEEDED: {
        return Object.assign({}, state, { loginStep: Constants.loginSteps.passwordResetSent, loginFailure: undefined, emailLoginFailure: undefined });
    }
    case types.COMPLETE_LOGIN_BY_EMAIL_SUCCEEDED: {
        return Object.assign({}, state, { redirectLocation: action.redirectTo });
    }
    case types.RESEND_USER_SETPASSWORD_EMAIL_SUCCEEDED: {
        return Object.assign({}, state, { loginStep: Constants.loginSteps.verifyEmailInfo, loginFailure: undefined, emailLoginFailure: undefined });
    }
    case types.START_RESET_PASSWORD_FAILED:
    case types.COMPLETE_LOGIN_BY_EMAIL_FAILED: {
        return Object.assign({}, state, { emailLoginFailure: getErrorMessage(action.error) });
    }
    case types.RESEND_USER_SETPASSWORD_EMAIL_FAILED: {
        return Object.assign({}, state, { loginFailure: getErrorMessage(action.error) });
    }
    case types.START_SSO_LOGIN_FAILED:
    case types.START_LOGIN_FAILED: {
        return Object.assign({}, state, { loginFailure: scrub(getErrorMessage(action.error)) });
    }
    default:
        return state;
    }
};

export default loginReducer;
